import { Button } from '@/components/Button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export const ResetSuccess = () => {
  const navigate = useNavigate();
  const handleMove = () => navigate('/login');
  const { t } = useTranslation();
  return (
    <div className="p-7 w-96 flex flex-col items-center py-6 h-48 justify-center">
      <span className="text-lg font-medium mb-6">
        {t('label.reset_success')}
      </span>
      <Button variant="contained" fullWidth type="submit" onClick={handleMove}>
        {t('auth.login.form.login')}
      </Button>
    </div>
  );
};
